"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsTargetBlankStr = exports.checkLinkIsMatched = exports.checkPathname = exports.convertlinkChildrenToArray = exports.convertHrefToLinkString = void 0;
exports.convertHrefToLinkString = function (href) { return (typeof href === 'undefined' ? '' : href); };
exports.convertlinkChildrenToArray = function (linkChildren) { return (typeof linkChildren === 'undefined' ? [] : linkChildren); };
exports.checkPathname = function (linkStr, pathname) {
    if (!linkStr) {
        return false;
    }
    if (pathname === '/') {
        return linkStr === '/';
    }
    else {
        if (linkStr === '/') {
            return false;
        }
        else {
            return !!pathname.match(linkStr);
        }
    }
};
exports.checkLinkIsMatched = function (link, pathname) {
    if (link.children && link.children.length > 0) {
        var childrenLinks = link.children;
        var checkLinks = childrenLinks.find(function (link) {
            return exports.checkLinkIsMatched(link, pathname);
        });
        return !!checkLinks;
    }
    else {
        var linkStr = link.link;
        return exports.checkPathname(linkStr, pathname);
    }
};
exports.getIsTargetBlankStr = function (isTargetBlank) { return (!!isTargetBlank ? '_blank' : ''); };
